// extracted by mini-css-extract-plugin
export var adjacentSlide = "_of-9";
export var arrowButtonContainer = "_of-5";
export var arrowButtonIcon = "_of-6";
export var carouselArrowButton = "_of-2";
export var carouselElementContainer = "_of-1";
export var currentSlide = "_of-8";
export var left = "_of-3";
export var otherSlide = "_of-a";
export var productCarouselContainer = "_of-0";
export var right = "_of-4";
export var sliderOverflow = "_of-7";